import React, { FC } from 'react';
import { SystemButtonContent } from './SystemButton';
import { SystemButtonProps } from './button.types';

type Props = {
  large?: boolean;
  expanded?: boolean;
  className: string;
} & SystemButtonProps;

/**
 * Base of all our Design system buttons
 * It handles nullable type of button
 * Limitiation - Left & Right icons (SystemButtonContent) are dedecated to some specific cases (ex Warning buttons haven't)
 */

export const BaseButton: FC<Props> = ({
  children,
  iconLeft,
  iconRight,
  type,
  ...commonProps
}) => {
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
          {children}
        </SystemButtonContent>
      </button>
    );
  }
  return (
    <button type="button" {...commonProps}>
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        {children}
      </SystemButtonContent>
    </button>
  );
};
